







































import Vue from 'vue'
import { ReceiptDetail } from '@/types/api-docs'

export interface DataType {
  receipt: ReceiptDetail
  freeAddress: string
  isFormValid: boolean
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  rules: any
}

export default Vue.extend({
  props: {
    receiptProp: {
      type: Object,
      required: true,
    },
    freeAddressProp: {
      type: String,
      required: true,
    },
    isFormValidProp: {
      type: Boolean,
      required: true,
    },
  },
  data(): DataType {
    return {
      receipt: this.receiptProp,
      freeAddress: this.freeAddressProp,
      isFormValid: this.isFormValidProp,
      rules: {
        required: (value: string) => (value && !!String(value).length) || 'この項目は必須です',
      },
    }
  },
  watch: {
    receipt: {
      handler(newReceiptDetail: ReceiptDetail) {
        this.$emit('update:receiptProp', newReceiptDetail)
      },
      deep: true,
    },
    freeAddress: {
      handler(newFreeAddress: string) {
        this.$emit('update:freeAddressProp', newFreeAddress)
      },
    },
    isFormValid: {
      handler(valid: boolean) {
        this.$emit('update:isFormValidProp', valid)
      },
    },
  },
})
